const reCAPTCHA = {
  SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? "",
}

export default reCAPTCHA
